const PAYMENT_PROVIDERS = {
  PROVIDER: {
    SIMPLE: 0,
    SIMPLE_SZEP: 1
  },
  PROVIDERS_WITH_REFUND: [0]
};

export default PAYMENT_PROVIDERS;
